<div class="flex-vertical background-white width-100pc oui-elevation-04 rounded padding-32 gap-48 card">
  <div class="flex-vertical gap-8">
    <h6>Allocation d'actifs</h6>
  </div>
  <div class="flex-vertical gap-24" *ngIf="isGestionLibre">
    <div class="subtitle-1">Profils de risque</div>
    <div class="flex-vertical gap-16">
      <div class="oui-form-line flex-horizontal">
        <oui-select
          [ngClass]="
            currentFicheConseil?.versements?.avecVersementProgramme ? 'oui-form-field-md' : 'oui-form-field-lg'
          "
          [label]="labelProfilsRisqueVC"
          [control]="viRisqueControl"
          [options]="risqueOptions"
          [errors]="[requiredValueError]"></oui-select>
        <oui-select
          *ngIf="vpRisqueControl && currentFicheConseil?.versements?.avecVersementProgramme"
          class="oui-form-field-md"
          label="Versement programme"
          [control]="vpRisqueControl"
          [options]="risqueOptions"
          [errors]="[requiredValueError]"></oui-select>
      </div>
      <ng-container *ngTemplateOutlet="banner"></ng-container>
    </div>
  </div>
  <div class="flex-vertical gap-24">
    <div class="subtitle-1">{{ labelSubtitleVC }}<span class="color-primary-500">*</span></div>
    <div class="flex-vertical gap-24">
      <ng-container *ngIf="isGestionLibre">
        <div class="file-uploader-container flex-vertical gap-24">
          <oui-button-toggle
            [options]="optionnalAnnexeToggleOptions"
            [control]="optionnalAnnexeTogglecontrol"></oui-button-toggle>
          <ng-container *ngIf="optionnalAnnexeTogglecontrol.value == 1; else noAnnexe">
            <div
              class="body-1"
              [innerText]="textAnnexeOptimiz"
              *ngIf="!currentFicheConseil?.allocationConsultantFileId"></div>
            <app-allocation-consultant-file-upload
              [currentFile]="currentFicheConseil?.allocationConsultantFile"></app-allocation-consultant-file-upload>
            <div
              class="caption color-error"
              *ngIf="showLibreFileError && !currentFicheConseil?.allocationConsultantFileId">
              Vous devez ajouter un fichier
            </div>
          </ng-container>
          <ng-template #noAnnexe>
            <ng-container *ngIf="!dualZonePrimaryLabel || !dualZoneSecondaryLabel; else dualZoneLibre">
              <div class="body-1" [innerText]="textZoneLibre"></div>
              <oui-textarea
                [control]="portefeuilleDetailsControl"
                [errors]="[requiredValueError]"
                placeholder="Saisissez vos precisions*"
                [resizeEnabled]="true"></oui-textarea>
            </ng-container>
            <ng-template #dualZoneLibre>
              <app-allocation-zone-libre-dual-textarea
                class="width-100pc"
                [primaryControl]="arbitrageLibreSupportsSortantsControl"
                [secondaryControl]="arbitrageLibreSupportsEntrantsControl"
                [primaryLabel]="dualZonePrimaryLabel ?? ''"
                [secondaryLabel]="dualZoneSecondaryLabel ?? ''"
                [errors]="[requiredValueError]"></app-allocation-zone-libre-dual-textarea>
            </ng-template>
          </ng-template>
        </div>
      </ng-container>

      <ng-container *ngIf="!isGestionLibre">
        <div
          class="body-1"
          [innerText]="'Vous devez selectionner l allocation parmi celles proposees par le partenaire :'"
          *ngIf="!currentFicheConseil?.allocationConsultantFileId"></div>
        <div class="oui-form-line flex-horizontal flex-center">
          <oui-select
            class="oui-form-field-md fixHeight-48"
            label="Selectionnez l'allocation du contrat"
            [control]="allocationPartenaireControl"
            [options]="allocationPartenaireOptions"
            [errors]="[requiredValueError]"></oui-select>
          <oui-file-item
            *ngIf="partenaireFile && currentFicheConseil?.allocation"
            class="oui-form-field-md"
            [file]="partenaireFile"
            (fileClick)="onPartenaireFileClick()"
            [showDeleteButton]="false"></oui-file-item>
        </div>
        <ng-container *ngTemplateOutlet="banner"></ng-container>
      </ng-container>
    </div>
  </div>

  <div
    class="flex-vertical gap-24"
    *ngIf="currentFicheConseil?.versements?.souscriptionAvecTransfert && isGestionLibre">
    <div class="subtitle-1">Allocation du transfert<span class="color-primary-500">*</span></div>
    <div class="flex-vertical gap-24">
      <div class="flex-vertical gap-8">
        <div class="body-1">L'allocation du transfert et du versement initial sont :</div>
        <oui-button-toggle
          [options]="isTransfertIdenticalOptions"
          [control]="isTransfertIdenticalControl"></oui-button-toggle>
      </div>
    </div>
  </div>
  @if(showAllocationVP) {
  <div class="flex-vertical gap-24">
    <div class="subtitle-1">Allocation des versements programmes<span class="color-primary-500">*</span></div>
    <div class="flex-vertical gap-24">
      <div class="flex-vertical gap-8">
        <div class="body-1" [innerText]="vpAllocationText"></div>
        <oui-button-toggle
          [options]="isAllocationIdenticalOptions"
          [control]="isAllocationIdenticalControl"></oui-button-toggle>
      </div>
    </div>
  </div>
  }
</div>
<ng-template #banner>
  <app-allocation-rules-banner></app-allocation-rules-banner>
</ng-template>
